module.exports = __webpack_public_path__ + "static/media/zip_icon.ff423351.png";